export class ConditionalPrimitive {
    public name: string = "";
    public type: string = "";
    public namespace: string = "";

    toString() : string {
        if (this.namespace)
            return this.namespace + "." + this.name;
        else
            return this.name;
    }
}